<template>
<v-row wrap class="ma-0">
    <v-col cols="12" md="11" lg="10" xl="10" text-subtitle-1 font-weight-medium >
        <!-- largre -->
        <v-row v-if="journal" class="hidden-sm-and-down ml-5 mr-5" justify="space-around">
            <a title="Institute of Mathematics CAS"
                href="https://math.cas.cz"
                class="blue--text text--darken-4">
                <span class="mb-1">Publisher</span>
                <v-img
                    :src="require('../../../assets/library/im-logo.gif')"
                    max-height="64"
                    contain
                    class="ma-0"
                ></v-img>
            </a>
            <a :title="journal.distributor.title"
                :href="journal.distributor.url"
                class="blue--text text--darken-4">
                <span class="ml-0">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Distributor</span>
                <v-img
                    :src="require('../../../assets/library/springer-logo.png')"
                    max-height="64"
                    max-width="203"
                    contain
                    class="ma-0"
                ></v-img>
            </a>
            <a  title="DML"
                :href="journal.dml"
                target="_blanc"
                class="blue--text text--darken-4">
                <span class="mb-1">Archive of old issues</span>
                <v-img
                    :src="require('../../../assets/library/dmlczlogo.png')"
                    max-height="64"
                    contain
                    class="ma-0"
                ></v-img>
            </a>
        </v-row>
        <!-- small -->
        <v-row class="hidden-md-and-up" justify="center">
            <a title="Institute of Mathematics CAS"
                href="https://math.cas.cz"
                class="blue--text text--darken-4">
                <span class="mb-1">Publisher</span>
                <v-img
                    :src="require('../../../assets/library/im-logo.gif')"
                    max-height="64"
                    contain
                    class="ma-0"
                ></v-img>
            </a>
        </v-row>
        <!-- small -->
        <v-row v-if="journal" class="hidden-md-and-up mt-7 mb-0" justify="center">
            <a :title="journal.distributor.title"
                :href="journal.distributor.url"
                class="blue--text text--darken-4 my-0 py-0">Distributor
            </a>
        </v-row>
        <!-- small -->
        <v-row v-if="journal" class="hidden-md-and-up mt-O mb-7" justify="center">
            <a :title="journal.distributor.title"
                :href="journal.distributor.url"
                class="blue--text text--darken-4  my-0 py-0">
                <v-img
                    :src="require('../../../assets/library/springer-logo.png')"
                    max-height="64"
                    class="mx-0 mt-n4"
                ></v-img>
            </a>
        </v-row>
        <!-- small -->
        <v-row v-if="journal" class="hidden-md-and-up" justify="center">
            <a  title="DML"
                :href="journal.dml"
                target="_blanc"
                class="blue--text text--darken-4">
                <span class="mb-1">Archive of old issues</span>
                <v-img
                    :src="require('../../../assets/library/dmlczlogo.png')"
                    max-height="64"
                    contain
                    class="ma-0"
                ></v-img>
            </a>
        </v-row>
    </v-col>
</v-row>
</template>
<script>
import {mapGetters} from 'vuex';
export default {
       computed:{
        ...mapGetters('library',{
            journal:'journal',
        })
    },
}
</script>
